<template>
  <v-container fluid class="px-15 mx-15">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <v-form v-model="isValido">
      <v-row align="center">
        <v-col cols="12">
          <v-toolbar flat>
            <v-toolbar-title class="text-h5">| Relatório de Histórico de Alterações</v-toolbar-title>
          </v-toolbar>
          
          <span class="pl-4 text-subtitle-1">Essa tela consiste em visualizar um histórico de todas as alterações feitas na tela de 'Registro de Estoque' da unidade.</span>
        </v-col>

        <v-col cols="12" lg="6">
          <v-autocomplete
            v-model="formRelatorio.filtrosRelatorio.itensSelecionados"
            :items="listaDeItens"
            :loading="!listaDeItens"
            :readonly="!listaDeItens"
            :no-data-text="loadingAutocomplete.noDataTextProduto"
            chips
            multiple
            label="Filtrar por Produtos Padronizados"
            autocomplete="off"
            prepend-icon="mdi-file-table"
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="removeItem(data.item)"
              >
                {{ data.item.text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
  
        <v-col cols="12" lg="6">
          <v-autocomplete
            v-model="formRelatorio.filtrosRelatorio.tipoModificacao"
            :items="listaDeTipos"
            label="Tipo de Alteração"
            autocomplete="off"
            clearable
          ></v-autocomplete>
        </v-col>
        
        <v-col cols="12" lg="6">
          <v-menu
            v-model="menuDe"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model="formRelatorio.filtrosRelatorio.dataInicioFormatado"
                label="Data De:"
                hint="DD/MM/AAAA"
                persistent-hint
                prepend-icon="mdi-calendar"
                autocomplete="off"
                v-mask="['##/##/####']"
                @blur="formRelatorio.filtrosRelatorio.dataInicio = analizarData(formRelatorio.filtrosRelatorio.dataInicioFormatado)"
              ></v-text-field>
            </template>
            <v-date-picker v-model="formRelatorio.filtrosRelatorio.dataInicio" no-title @input="menuDe = false" @change="formRelatorio.filtrosRelatorio.dataInicioFormatado = formatarData(formRelatorio.filtrosRelatorio.dataInicio)"></v-date-picker>
          </v-menu>
        </v-col>
        
        <v-expand-x-transition>
          <v-col v-if="formRelatorio.filtrosRelatorio.dataInicio" cols="12" lg="6">
            <v-menu
              v-model="menuAte"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  v-model="formRelatorio.filtrosRelatorio.dataFimFormatado"
                  label="Data Até:"
                  hint="DD/MM/AAAA"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  autocomplete="off"
                  v-mask="['##/##/####']"
                  @blur="formRelatorio.filtrosRelatorio.dataFim = analizarData(formRelatorio.filtrosRelatorio.dataFimFormatado)"
                ></v-text-field>
              </template>
              <v-date-picker v-model="formRelatorio.filtrosRelatorio.dataFim" no-title @input="menuAte = false" @change="formRelatorio.filtrosRelatorio.dataFimFormatado = formatarData(formRelatorio.filtrosRelatorio.dataFim)"></v-date-picker>
            </v-menu>
          </v-col>
        </v-expand-x-transition>

        <v-col cols="12" align="center">
          <v-btn
            :disabled="btnGerarRelatorio"
            width="300"
            color="#3cbc62"
            class="white--text"
            @click="gerarRelatorio"
          >
            GERAR RELATÓRIO
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <Loading :open="loading" />

    <FormRelatorio
      :isTheModalOpen="formRelatorio.isOpen"
      :modalTitleToolbar="formRelatorio.modalTitleToolbar"
      v-on:fecharModal="formRelatorioClose"
      v-on:generate-excel="saveExcel(formRelatorio.dataRelatorio)"
    >
      <v-row class="pa-4">
        <v-col cols="12">
          <v-card elevation="0">
            <v-card-title v-if="formRelatorio.dataRelatorio.funcionarioSelecionado == null">• Histórico de Alterações</v-card-title>
            <v-card-title v-if="formRelatorio.dataRelatorio.funcionarioSelecionado != null">• Histórico de Alterações - {{ formRelatorio.dataRelatorio.funcionarioSelecionado }}</v-card-title>
            <v-card-subtitle v-if="formRelatorio.dataRelatorio.dataInicio && !formRelatorio.dataRelatorio.dataFim && formRelatorio.dataRelatorio.itensAlterados.length > 0" class="pl-10 pt-3">
              <b>Alterados nas datas de {{ formRelatorio.dataRelatorio.dataInicio }} até {{ formatarData(new Date().toISOString().substr(0, 10)) }}</b>
            </v-card-subtitle>
            <v-card-subtitle v-if="formRelatorio.dataRelatorio.dataInicio && formRelatorio.dataRelatorio.dataFim && formRelatorio.dataRelatorio.itensAlterados.length > 0" class="pl-10 pt-3">
              <b>Alterados nas datas de {{ formRelatorio.dataRelatorio.dataInicio }} até {{ formRelatorio.dataRelatorio.dataFim }}</b>
            </v-card-subtitle>

            <v-row class="pb-16">
              <v-col v-if="formRelatorio.dataRelatorio.itensAlterados.length > 0" cols="12">
                <DataTable
                  :tableHeader="headers"
                  :tableRows="formRelatorio.dataRelatorio.itensAlterados"
                ></DataTable>
              </v-col>
              <v-col v-else cols="12">
                <v-card-text>
                  <span class="text-subtitle-1 font-weight-light">Não é possível de exibir a tabela dos produtos alterados, pois, não há dados suficientes.</span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </FormRelatorio>
  </v-container>
</template>
  
<script>
  import axios from "../plugins/axios";
  import store from "@/store/index";
  import FormRelatorio from "../components/FormRelatorio";
  import DataTable from "@/components/DataTable2.vue";
  import Alertas from "../components/Alertas.vue";
  import Loading from "../components/Loading.vue";
  import { Workbook } from "exceljs";
  import { saveAs } from "file-saver";
  import Blob from "blob";
  
  export default {
    components: {
      FormRelatorio,
      DataTable,
      Loading,
      Alertas
    },
  
    data: () => ({
      //#region Alertas
      alerta: {
        texto: "",
        tipo: ""
      },
  
      alertaSocket: {
        texto: "",
        tipo: "",
      },
  
      alertaModal: {
        texto: "",
        tipo: "",
      },
  
      alertaSnackbar: {
        mostrar: false,
        texto: null,
        cor: "red"
      },
      //#endregion
  
      rules: {
        required: (value) => value.length > 0 || "Requer o campo!",
        requeridoTipo: (value) => value != null || "Requer o campo!",
      },
      dataRules: [(v) => (v && v.length >= 10) || "Data contém formato inválido!"],


      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },
  
      headers: [
        {
          text: "Tipo Alteração",
          value: "tipoModificacao",
        },
        {
          text: "Item (Padronizado)",
          value: "nomeItemPadronizado",
        },
        {
          text: "Item (Não Padronizado)",
          value: "nomeItemNaoPadronizado",
        },
        {
          text: "Qt. Anterior",
          value: "quantidadeAnterior",
        },
        {
          text: "Qt. Posterior",
          value: "quantidadePosterior",
        },
        {
          text: "Data da Alteração",
          value: "dataRegistro",
        },
        {
          text: "Funcionário",
          value: "nomeFuncionario",
        },
        {
          text: "Unidade",
          value: "nomeUnidade",
        },
      ],
  
      loadingAutocomplete: {
        noDataTextProduto: "Carregando a lista de produtos...",
        noDataTextFuncionario: "Carregando a lista de funcionários...",
      },

      formRelatorio: {
        isOpen: false,
        modalTitleToolbar: "Relatório de Histórico de Alterações",
        filtrosRelatorio: {
          numeroEndereco: store.state.numeroEndereco,
          numeroFuncionario: null,
          tipoModificacao: null,
          dataInicio: null,
          dataInicioFormatado: null,
          dataFim: null,
          dataFimFormatado: null,
          itensSelecionados: []
        },
        dataRelatorio: {
          dataInicio: null,
          dataFim: null,
          funcionarioSelecionado: null,
          itensAlterados: [],
        },
      },
      
      //DatePicker
      menuDe: false,
      menuAte: false,
  
      page: 1,
  
      btnGerarRelatorio: false,
      isValido: true,
      loading: false,
      temSubestoque: false,
  
      listaDeItens: [],
      listaDeTipos: [
        {
          value: 0,
          text: 'Registro'
        },
        {
          value: 1,
          text: 'Atualização'
        },
        {
          value: 2,
          text: 'Remoção'
        }
      ]
    }),
  
    created() {
      this.mostrarSkeleton = true;
      this.inicializar();
    },
  
    watch: {
      isValido() {
        this.btnGerarRelatorio = !this.isValido;
      },
    },
  
    methods: {
      //#region LISTAGENS
      async inicializar() {
        try {
          this.listarItens();
        } catch (error) {
          console.log(error);
          this.alerta.texto = error.response.data.message;
          this.alerta.tipo = 'erro';
        } finally {
          this.mostrarSkeleton = false;
        }
      },
  
      async listarItens() {
        try {
          this.btnGerarRelatorio = true

          const responseItens = await axios.put("itemSistemaUnidade", {numeroEndereco: store.state.numeroEndereco}, this.config);

          if(responseItens.data.length == 0) {
            this.loadingAutocomplete.noDataTextProduto = "Não há produtos cadastrados"
          }

          this.listaDeItens = responseItens.data.map((row) => {
            return { 
              value: row.itemSistemaUnidade.numeroItemSistemaUnidade,
              text: row.itemSistema.nomeItemSistema,
              numeroItemSistema: row.itemSistema.numeroItemSistema,
              numeroItemSistemaUnidade: row.itemSistemaUnidade.numeroItemSistemaUnidade,
              quantidadeEstoque: row.quantidadeEstoqueTotal,
            };
          });
        } catch (error) {
          this.alerta.texto = error.response.data.message;
          this.alerta.tipo = "erro";
        } finally {
          this.btnGerarRelatorio = false
        }
      },
      //#endregion
      
      async gerarRelatorio() {
        this.alerta.tipo = "";
        this.loading = true;
        try {
          const responseRelatorio = await axios.put(
            "relatorioHistoricoAlteracao",
            this.formRelatorio.filtrosRelatorio,
            this.config
          );
          
          this.formRelatorio.dataRelatorio.itensAlterados = responseRelatorio.data.itensAlterados;
          this.formRelatorio.dataRelatorio.dataInicio = this.formRelatorio.filtrosRelatorio.dataInicioFormatado;
          this.formRelatorio.dataRelatorio.dataFim = this.formRelatorio.filtrosRelatorio.dataFimFormatado;
          this.formRelatorio.dataRelatorio.funcionarioSelecionado = null;
          if(this.formRelatorio.filtrosRelatorio.numeroFuncionario) {
            const funcionario = this.listaDeFuncionarios.filter(
              (funcionarioSelecionado) => funcionarioSelecionado.value == this.formRelatorio.filtrosRelatorio.numeroFuncionario
            );
            
            this.formRelatorio.dataRelatorio.funcionarioSelecionado = funcionario[0].text;
          }
  
        } catch (error) {
          this.alerta.texto = error.response.data.message;
          this.alerta.tipo = "erro";
        } finally {
          this.loading = false;
          this.formRelatorio.isOpen = true;
        }
      },
  
      formRelatorioClose() {
        this.formRelatorio.dataRelatorio.dataInicio = null;
        this.formRelatorio.dataRelatorio.dataFim = null;
        this.formRelatorio.dataRelatorio.funcionarioSelecionado = null;
        this.formRelatorio.dataRelatorio.itensAlterados = [];
  
        this.formRelatorio.isOpen = false;
      },
  
      removeItem(item) {
        const index = this.formRelatorio.filtrosRelatorio.itensSelecionados.indexOf(item.value);
        if (index >= 0)
          this.formRelatorio.filtrosRelatorio.itensSelecionados.splice(index, 1);
      },
  
      //#region Excel
      saveExcel(conteudo) {
        try {
          const dataSelecionada = conteudo.dataInicio ? " | De " + conteudo.dataInicio + " até " + (conteudo.dataFim ? conteudo.dataFim : this.formatarData(new Date().toISOString().substr(0, 10))) : "";

          const workbook = new Workbook();

          var borderStyles = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          
          var worksheet = workbook.addWorksheet("Histórico de Alterações", {
            properties: { tabColor: { argb: "FF00FF00" } },
            views: [{ showGridLines: false }],
          });

          worksheet.columns = [
            { key: "col1", width: 25 },
            { key: "col2", width: 40 },
            { key: "col3", width: 40 },
            { key: "col4", width: 20 },
            { key: "col5", width: 20 },
            { key: "col6", width: 25 },
            { key: "col7", width: 30 },
            { key: "col8", width: 40 },
          ];

          let posicaoLinha = 1;
          worksheet.getRow(posicaoLinha).height = 30;
          worksheet.mergeCells('A'+posicaoLinha+':H'+posicaoLinha);
          worksheet.getCell('A'+posicaoLinha).value = 'Histórico de Alterações' + dataSelecionada;
          worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 14, bold: true };
          worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };
          worksheet.getCell('A'+posicaoLinha).fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'66cc99'},
          };
          posicaoLinha++

          if(conteudo.itensAlterados.length > 0) {
            worksheet.getRow(posicaoLinha).height = 20;
            worksheet.getCell('A'+posicaoLinha).value = "Tipo Alteração";
            worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 11, bold: true };
            worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };

            worksheet.getCell('B'+posicaoLinha).value = "Item (Padronizado)";
            worksheet.getCell('B'+posicaoLinha).font = { name: 'Arial', family: 2, size: 11, bold: true };
            worksheet.getCell('B'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };

            worksheet.getCell('C'+posicaoLinha).value = "Item (Não Padronizado)";
            worksheet.getCell('C'+posicaoLinha).font = { name: 'Arial', family: 2, size: 11, bold: true };
            worksheet.getCell('C'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };

            worksheet.getCell('D'+posicaoLinha).value = "Qt. Anterior";
            worksheet.getCell('D'+posicaoLinha).font = { name: 'Arial', family: 2, size: 11, bold: true };
            worksheet.getCell('D'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };

            worksheet.getCell('E'+posicaoLinha).value = "Qt. Posterior";
            worksheet.getCell('E'+posicaoLinha).font = { name: 'Arial', family: 2, size: 11, bold: true };
            worksheet.getCell('E'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };

            worksheet.getCell('F'+posicaoLinha).value = "Data da Alteração";
            worksheet.getCell('F'+posicaoLinha).font = { name: 'Arial', family: 2, size: 11, bold: true };
            worksheet.getCell('F'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };

            worksheet.getCell('G'+posicaoLinha).value = "Funcionário";
            worksheet.getCell('G'+posicaoLinha).font = { name: 'Arial', family: 2, size: 11, bold: true };
            worksheet.getCell('G'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };

            worksheet.getCell('H'+posicaoLinha).value = "Unidade";
            worksheet.getCell('H'+posicaoLinha).font = { name: 'Arial', family: 2, size: 11, bold: true };
            worksheet.getCell('H'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };
            posicaoLinha++
            
            conteudo.itensAlterados.map((itemSelecionado) => {
              worksheet.getRow(posicaoLinha).height = 20;
              worksheet.getCell('A'+posicaoLinha).value = this.formataTipoModificacao(itemSelecionado.tipoModificacao);
              worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 12 };
              worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };

              if(itemSelecionado.nomeItemPadronizado) {
                worksheet.getCell('B'+posicaoLinha).value = itemSelecionado.nomeItemPadronizado;
                worksheet.getCell('B'+posicaoLinha).font = { name: 'Arial', family: 2, size: 12 };
                worksheet.getCell('B'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
              } else {
                worksheet.getCell('B'+posicaoLinha).value = "Não padronizado";
                worksheet.getCell('B'+posicaoLinha).font = { name: 'Arial', family: 2, size: 12, color: {argb: '9E9E9E'} };
                worksheet.getCell('B'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
              }
              
              worksheet.getCell('C'+posicaoLinha).value = itemSelecionado.nomeItemNaoPadronizado;
              worksheet.getCell('C'+posicaoLinha).font = { name: 'Arial', family: 2, size: 12 };
              worksheet.getCell('C'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
              
              if(itemSelecionado.quantidadeAnterior) {
                worksheet.getCell('D'+posicaoLinha).value = itemSelecionado.quantidadeAnterior;
                worksheet.getCell('D'+posicaoLinha).font = { name: 'Arial', family: 2, size: 12 };
                worksheet.getCell('D'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };
              } else {
                worksheet.getCell('D'+posicaoLinha).value = "Sem quantidade";
                worksheet.getCell('D'+posicaoLinha).font = { name: 'Arial', family: 2, size: 12, color: {argb: '9E9E9E'} };
                worksheet.getCell('D'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
              }
              
              if(itemSelecionado.quantidadePosterior) {
                worksheet.getCell('E'+posicaoLinha).value = itemSelecionado.quantidadePosterior;
                worksheet.getCell('E'+posicaoLinha).font = { name: 'Arial', family: 2, size: 12 };
                worksheet.getCell('E'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };
              } else {
                worksheet.getCell('E'+posicaoLinha).value = (itemSelecionado.tipoModificacao && itemSelecionado.tipoModificacao == 1) ? "Não Alterado" : "Sem quantidade";
                worksheet.getCell('E'+posicaoLinha).font = { name: 'Arial', family: 2, size: 12, color: {argb: '9E9E9E'} };
                worksheet.getCell('E'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
              }
              
              worksheet.getCell('F'+posicaoLinha).value = this.formatarDataBancoTipoPadrao(itemSelecionado.dataRegistro);
              worksheet.getCell('F'+posicaoLinha).font = { name: 'Arial', family: 2, size: 12 };
              worksheet.getCell('F'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };
              
              worksheet.getCell('G'+posicaoLinha).value = itemSelecionado.nomeFuncionario;
              worksheet.getCell('G'+posicaoLinha).font = { name: 'Arial', family: 2, size: 12 };
              worksheet.getCell('G'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
              
              worksheet.getCell('H'+posicaoLinha).value = itemSelecionado.nomeUnidade;
              worksheet.getCell('H'+posicaoLinha).font = { name: 'Arial', family: 2, size: 12 };
              worksheet.getCell('H'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

              const nomeItemPadronizadoLength = itemSelecionado.nomeItemPadronizado ? itemSelecionado.nomeItemPadronizado.length : 0;
              const nomeItemNaoPadronizadoLength = itemSelecionado.nomeItemNaoPadronizado ? itemSelecionado.nomeItemNaoPadronizado.length : 0;
              const nomeFuncionarioLength = itemSelecionado.nomeFuncionario ? itemSelecionado.nomeFuncionario.length : 0;
              const nomeUnidadeLength = itemSelecionado.nomeUnidade ? itemSelecionado.nomeUnidade.length : 0;

              const max = Math.max(nomeItemPadronizadoLength, nomeItemNaoPadronizadoLength, nomeFuncionarioLength, nomeUnidadeLength);
              
              const numLines = Math.ceil(max / 30);
              worksheet.getRow(posicaoLinha).height = numLines * 15;
              posicaoLinha++
            });
          } else {
            worksheet.mergeCells('A'+posicaoLinha+':H'+posicaoLinha);
            worksheet.getCell('A'+posicaoLinha).value = 'Não é possível de exibir a tabela dos produtos alterados, pois, não há dados suficientes.';
            worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 13, bold: false };
            worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'center' };
            posicaoLinha++
          }
          
          worksheet.eachRow({ includeEmpty: true }, function(row) {
            row.eachCell({ includeEmpty: true }, function(cell) {
              cell.border = borderStyles;
            });
          });

          workbook.xlsx.writeBuffer().then(function(data) {
            var blob = new Blob([data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Relatorio de Histórico de Alterações.xlsx");
          });
        } catch (error) {
          console.log(error);
        }
      },
      //#endregion
    
      //#region FORMATERS
      formataTipoModificacao(status) {
        switch (status) {
          case 0: return "Registro";
          case 1: return "Atualização";
          case 2: return "Remoção";
        }
      },

      analizarData(date) {
        if (!date) return null;

        const [day, month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      },
      
      formatarData(date) {
        if (!date) return null;

        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      },

      formatarDataBancoTipoPadrao(data) {
        if(data) {
          var ano  = data.split("-")[0];
          var mes  = data.split("-")[1];
          var dia  = data.split("-")[2];
          var dia2  = dia.substring(0,2)
          
          return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        } else {
          return null;
        }
      }
      //#endregion
    },
  };
  </script>
  